export const REPO_CONFIG = { organization: 'Teladoc', repo: 'telapp' } as const;

export const formatDate = (dateString: string): string => {
  const diffMs = Date.now() - new Date(dateString).getTime();
  const totalMins = Math.floor(diffMs / 60000);
  const hours = Math.floor(totalMins / 60);
  const days = Math.floor(hours / 24);
  if (totalMins < 1) return '< 1m ago';
  if (totalMins < 60) return `${totalMins}m ago`;
  if (hours < 24) return `${hours}h ${totalMins % 60}m ago`;
  return `${days}d ${hours % 24}h ago`;
};

export const formatFullDateTime = (dateString: string): string =>
  new Date(dateString).toLocaleString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric',
    hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
  });

export const formatDuration = (startISO: string, endISO: string): string => {
  const diffMs = new Date(endISO).getTime() - new Date(startISO).getTime();
  if (diffMs <= 0) return '< 1m';
  const totalMins = Math.floor(diffMs / 60000);
  const days = Math.floor(totalMins / (60 * 24));
  const hours = Math.floor((totalMins % (60 * 24)) / 60);
  const mins = totalMins % 60;
  if (days > 0) return hours > 0 ? `${days}d ${hours}h` : `${days}d`;
  if (hours > 0) return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  return `${mins}m`;
};
